export default "__VITE_ASSET__CZlIDfNF__"